import PassCodeContainer from "./PassCodeContainer";

export default PassCodeContainer;
